import { useMutation, useQueryClient } from '@tanstack/react-query'
import { authApiClient } from '~/lib/api-client'
import { toast } from 'sonner'
import { useTranslations } from 'use-intl'

export function useUpdateFavoriteNote() {
  const queryClient = useQueryClient()
  const t = useTranslations('favorites')

  return useMutation({
    mutationFn: async ({ shopId, note, tags }: { shopId: number; note: string; tags?: string[] }) => {
      const res = await (authApiClient as any).users.me.favorites[':shopId'].$patch({
        param: { shopId: String(shopId) },
        json: { note, ...(tags !== undefined ? { tags } : {}) },
      })
      if (!res.ok) {
        throw new Error('Failed to update note')
      }
      return res.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['favorites', 'list'] })
      queryClient.invalidateQueries({ queryKey: ['nearby-shops'] })
      toast.success(t('noteSaved', { defaultValue: 'Note saved successfully' }))
    },
    onError: () => {
      toast.error(t('noteSaveFailed', { defaultValue: 'Failed to save note' }))
    },
  })
}
